import axios from 'axios'
import { baseURL, oauth2ClientId, oauth2ClientSecret, oauthPrefix } from './Config'
import { axiosClient } from '../Network/AxiosClient'

const scope = "user"
const role = "CMS"
const grantType = "password"

function oauthLogin(username, password, callback, errorCallback){
    let url = baseURL + "/oauth/token"
    
    var formData = new FormData()
    formData.append("client_id", oauth2ClientId)
    formData.append("client_secret", oauth2ClientSecret)
    formData.append("scope", scope)
    formData.append("grant_type", grantType)
    formData.append("username", role + "|" + username)
    formData.append("password", password)

    axios({
        url: url,
        method: 'POST',
        data: formData,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Basic ${btoa(`${oauth2ClientId}:${oauth2ClientSecret}`)}`,
        }
    })
    .then((response)=>{
        let data = response.data
        let token = data.access_token
        localStorage.setItem("is_auth", true)
        localStorage.setItem("access_token", token)
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function forgotPassword(email, callback, errorCallback){
    //let url = baseURL + "/password/forgot"
    let url = "https://visitor-api.lifelink.co.th:8082/lifelink/api/v1/password/forgot"
    var formData = new FormData()
    formData.append("email", email)

    axios({
        url: url,
        method: "POST",
        data: formData
    })
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function resetPassword(token, newPassword, confirmPassword, callback, errorCallback){
    let url = baseURL + "/password/reset"

    var formData = new FormData()
    formData.append("token", token)
    formData.append("password", newPassword)
    formData.append("rePassword", confirmPassword)

    axios({
        url: url,
        method: "POST",
        data: formData
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function checkUser(callback, errorCallback){
    let url = baseURL + "/account/get"
    let accessToken = oauthPrefix + localStorage.getItem("access_token")

    axios({
        url: url,
        method: 'GET',
        headers:{
            Authorization: accessToken
        }
    })
    .then((response)=>{
        let userData = response.data
        callback(userData)
    })
    .catch((error)=>{
        localStorage.removeItem("access_token")
        errorCallback(error)
    })
}

function activateUser(token, callback, errorCallback){
    let url = baseURL + "/account/register/activate"

    var bodyData = new FormData()
    bodyData.append("token", token)

    axios({
        url: url,
        method: "POST",
        data: bodyData
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function changePassword(oldPassword, newPassword, confirmPassword, callback, errorCallback){
    let url = baseURL + "/password/changePassword"
    let accessToken = oauthPrefix + localStorage.getItem("access_token")

    var bodyData = new FormData()
    bodyData.append("oldPassword", oldPassword)
    bodyData.append("newPassword", newPassword)
    bodyData.append("confirmPassword", confirmPassword)

    axios({
        url: url,
        method: "POST",
        data: bodyData,
        headers:{
            Authorization: accessToken
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function saveLog(callback, errorCallback){
    let url = baseURL + "/account/saveLog"
    let accessToken = oauthPrefix + localStorage.getItem("access_token")

    axios({
        url: url,
        method: "POST",
        headers:{
            Authorization: accessToken
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listBuildingLogin(){
    return new Promise((resolve, reject) => {
        const url = '/building/login/list'
        axiosClient.get(url)
        .then((res) => {
            const data = res.data
            resolve(data)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

function buildingLogin(buildingId, isDefault){
    return new Promise((resolve, reject) => {
        const url = `/building/login`
        var body = new FormData()
        body.append("building_id", buildingId)
        body.append("is_default", isDefault)
        axiosClient.post(url, body)
        .then((res) => {
            const data = res.data
            resolve(data)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

function removeBuildingLogin(){
    return new Promise((resolve, reject) => {
        const url = `/building/login/delete`
        axiosClient.post(url)
        .then((res) => {
            resolve(res)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

export { 
    oauthLogin, 
    forgotPassword, 
    checkUser, 
    resetPassword, 
    activateUser, 
    changePassword, 
    saveLog, 
    listBuildingLogin, 
    buildingLogin,
    removeBuildingLogin
}